<i18n>
{
  "fr": {
    "title-1": "Se connecter",
    "title-2": "S'enregistrer",
    "label-1": "Email",
    "label-2": "Mot de passe",
    "label-3": "Confirmation du mot de passe",
    "label-4": "Mot de passe oublié ?",
    "msg-1": "Un <strong>lien d'activation</strong> vous a été <strong>envoyé par email</strong>, veuillez cliquer dessus afin d'activer et utiliser votre compte.",
    "msg-2": "Un utilisateur avec cet email existe déjà.",
    "msg-3": "Les deux mots de passes fournis ne sont pas identiques.",
    "msg-4": "Aucun compte actif n'a été trouvé avec les informations d'identification données."
  },
  "en": {
    "title-1": "Login",
    "title-2": "Sign in",
    "label-1": "Email",
    "label-2": "Password",
    "label-3": "Password confirmation",
    "label-4": "Forgot your password ?",
    "msg-1": "An <strong>activation link</strong> has been <strong>sent by email</strong>, please click on it to activate and use your account.",
    "msg-2": "A user with this email address already exists.",
    "msg-3": "The two passwords provided are not identical.",
    "msg-4": "No active account found with the given credentials."
  }
}
</i18n>

<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body">
      <b-tabs v-model="activeTab" position="is-centered">
        <b-tab-item
          icon="user"
          :label="$t('title-1')"
          value="connection"
        >
          <div class="box-red" v-if="connectionError">
              {{ connectionError }}
          </div>
          <br v-if="connectionError"/>
          <form @submit.prevent="login()">
            <b-field :label="$t('label-1') + ' *'">
              <b-input v-model="connectUser.email"
                required="required"
                type="email"
                :placeholder="$t('label-1') + ' *'">
              </b-input>
            </b-field>
            <b-field :label="$t('label-2') + ' *'">
              <b-input v-model="connectUser.password"
                type="password"
                required="required"
                :placeholder="$t('label-2') + ' *'"
                password-reveal></b-input>
            </b-field>
            <button
              class="button is-primary
              is-fullwidth"
              type="submit"
            >
              <span class="icon is-small"><i class="fa fa-paper-plane"></i></span>
              <span>{{ $t('title-1') }}</span>
            </button>
            <br />
            <p class="has-text-centered">
              <router-link
                v-on:click.native="resetPassword()"
                class="link" :to="{ name: 'reset-password' }"
              >
                {{ $t('label-4') }}
              </router-link>
            </p>
          </form>
        </b-tab-item>
        <b-tab-item
          icon="pencil"
          :label="$t('title-2')"
          value="registration"
        >
          <b-notification v-if="linkSent" :closable="false">
            <span v-html="$t('msg-1')" />
          </b-notification>
          <div v-else>
            <div class="box-red" v-if="registrationError">
                {{ registrationError }}
            </div>
            <br v-if="registrationError"/>
            <form @submit.prevent="signIn()">
              <b-field label="Email *">
                <b-input v-model="registertUser.email"
                  type="email"
                  placeholder="Email *">
                </b-input>
              </b-field>
              <b-field :label="$t('label-2') + ' *'">
                <b-input v-model="registertUser.password1"
                  type="password"
                  :placeholder="$t('label-2') + ' *'">
                </b-input>
              </b-field>
              <b-field :label="$t('label-3') + ' *'">
                <b-input v-model="registertUser.password2"
                  type="password"
                  @keydown.enter="validate"
                  :placeholder="$t('label-3') + ' *'">
                </b-input>
              </b-field>
              <button
                class="button is-primary is-fullwidth"
                type="submit"
              >
                <span class="icon is-small"><i class="fa fa-paper-plane"></i></span>
                <span>{{ $t('title-2') }}</span>
              </button>
            </form>
          </div>
        </b-tab-item>
      </b-tabs>
    </section>
  </div>

</template>

<script>
import authenticationService from '@/services/authenticationService'
import { useAuthenticationStore } from '@/stores/authentication.js'

export default {
  name: 'AuthModal',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      linkSent: false,
      activeTab: 'connection',
      connectUser: {
        email: null,
        password: null
      },
      registertUser: {
        email: null,
        password1: null,
        password2: null
      },
      connectionError: '',
      registrationError: ''
    }
  },
  setup () {
    const authStore = useAuthenticationStore()
    return { authStore }
  },
  methods: {
    resetPassword () {
      this.$parent.close()
    },
    resetConnectionForm () {
      this.connectUser = {
        email: null,
        password: null
      }
      this.connectionError = ''
    },
    resetRegistrationForm () {
      this.registertUser = {
        email: null,
        password1: null,
        password2: null
      }
      this.registrationError = ''
    },
    login () {
      this.connectUser.email = this.connectUser.email.toLowerCase()
      let { email, password } = this.connectUser
      this.authStore.authRequest({ email, password })
        .then(() => {
          this.$parent.close()
        })
        .catch((erreur) => {
          if ('detail' in erreur.response.data) {
            if (erreur.response.data.detail === 'No active account found with the given credentials') {
              this.connectionError = this.$t('msg-4')
            } else {
              this.connectionError = erreur.response.data
            }
          } else {
            this.connectionError = erreur.response.data
          }
        })
    },
    signIn () {
      this.registertUser.email = this.registertUser.email.toLowerCase()
      authenticationService.register(this.registertUser)
        .then(data => {
          this.linkSent = true
        })
        .catch((erreur) => {
          if ('email' in erreur.response.data) {
            this.registrationError = this.$t('msg-2')
          } else if ('non_field_errors' in erreur.response.data) {
            this.registrationError = this.$t('msg-3')
          } else {
            this.registrationError = erreur.response.data
          }
        })
    }
  },
  watch: {
    activeTab: function () {
      if (this.activeTab === 'connection') {
        this.resetRegistrationForm()
      } else {
        this.resetConnectionForm()
      }
    }
  }
}
</script>
